<script>
import Main from './main.vue';
import Api from '@/utils/api';

export default Main.extend({
  methods: {
    getData() {
      return Api.dashboard.getVendorKpi.document(this.ajaxParams).then((resp) => {
        if (resp.data.Data) {
          return [
            {
              name: 'Document type(s)',
              data: [{
                x: 0,
                y: 1,
                data: resp.data.Data.ElementsCount,
              }],
            },
          ];
        }
      });
    },
  },
});
</script>
